// DateFilters.tsx
import React from "react";
import { RefreshCw } from "lucide-react";

interface DateFiltersProps {
  dateRange: { start: string; end: string };
  setDateRange: (range: { start: string; end: string }) => void;
}

// Utility to get today's date in 'YYYY-MM-DD' format
const getToday = () => new Date().toISOString().split("T")[0];

const DateFilters: React.FC<DateFiltersProps> = ({
  dateRange,
  setDateRange,
}) => {
  const today = getToday();

  const handleStartChange = (value: string) => {
    const newStart = value;
    const newEnd = dateRange.end;
    // Ensure start <= end
    if (newEnd && newStart > newEnd) {
      setDateRange({ start: newStart, end: newStart });
    } else {
      setDateRange({ ...dateRange, start: newStart });
    }
  };

  const handleEndChange = (value: string) => {
    const newEnd = value;
    const newStart = dateRange.start;
    // Ensure end >= start
    if (newStart && newEnd < newStart) {
      setDateRange({ start: newEnd, end: newEnd });
    } else {
      setDateRange({ ...dateRange, end: newEnd });
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 items-center justify-center mb-8 text-gray-800">
      {/* Start Date Field */}
      <label htmlFor="start-date" className="flex items-center gap-2">
        <span>Start Date:</span>
        <input
          id="start-date"
          type="date"
          max={today}
          className="p-2 border rounded bg-white text-[#333] shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          value={dateRange.start || today}
          onChange={(e) => handleStartChange(e.target.value)}
        />
      </label>

      {/* End Date Field */}
      <label htmlFor="end-date" className="flex items-center gap-2">
        <span>End Date:</span>
        <input
          id="end-date"
          type="date"
          max={today}
          className="p-2 border rounded bg-white text-[#333] shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          value={dateRange.end || today}
          onChange={(e) => handleEndChange(e.target.value)}
        />
      </label>

      {/* Reset Button */}
      <button
        onClick={() => setDateRange({ start: today, end: today })}
        className="flex items-center px-4 py-2 bg-[#032c58] hover:bg-[#021b36] text-white rounded shadow"
      >
        <RefreshCw size={16} className="mr-2" />
        Reset
      </button>
    </div>
  );
};

export default DateFilters;
